<template>
    <div v-if="!cookieConsent" class="cookie-consent">
      <p>We use cookies to enhance your browsing experience. Please accept our cookie policy.
        <a href="https://oc.aconcloud.net/privacy/?id=AconDDMPrivacyPolicy" target="_blank">Privacy Policy</a> 
      and 
      <a href="https://oc.aconcloud.net/privacy/?id=AconDDMTermsOfUse" target="_blank">Terms of Use</a>.
      </p>
      <button @click="acceptCookies">accept</button>
      <button @click="declineCookies">declined</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        cookieConsent: this.getCookie('cookieConsent'),
      };
    },
    methods: {
      acceptCookies() {
        this.setCookie('cookieConsent', 'accepted', 365);
        this.cookieConsent = 'accepted';
      },
      declineCookies() {
        this.setCookie('cookieConsent', 'declined', 365);
        this.cookieConsent = 'declined';
      },
      setCookie(name, value, days) {
        let expires = "";
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
    }
  };
  </script>
  
  <style scoped>
  .cookie-consent {
    position: fixed;
    bottom: 10px;
    left: 10px;
    right: 10px;
    background-color: #f8f9fa;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
  }
  
  .cookie-consent p {
    margin: 0;
    flex: 1;
    font-size: 16px;
  }
  
  .cookie-consent button {
    margin-left: 10px;
    padding: 8px 12px;
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .cookie-consent button:hover {
    background-color: #0056b3;
  }
  </style>